'use client';

import { useRef } from 'react';

/**
 * Hook to get the previous value of a state or prop
 * Useful for tracking transitions and changes
 */
export function usePrevious<T>(value: T): T | undefined {
    const ref = useRef<T | undefined>(undefined);
    const previousValue = ref.current;
    ref.current = value;
    return previousValue;
}
